import type { OpsAnnounceNotificationRequest } from '@nadoutong/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { AUDIT_ROOT_KEY } from './useAudit.ts';
import { announceNotification } from './notificationAnnouncements.ts';
import type { AnnounceNotificationResult } from './notificationAnnouncements.ts';

/**
 * React Query mutation for the fleet-wide announcement broadcast.
 *
 * Invalidates the audit root, which is where the send history on the
 * announcements page reads from (#1946) — the send itself is the audit row,
 * so a successful broadcast makes every cached audit page stale, not just the
 * one filtered to `notification.announced`.
 */
export function useAnnounceNotification(): UseMutationResult<
  AnnounceNotificationResult,
  Error,
  OpsAnnounceNotificationRequest
> {
  const { fetchImpl } = useSession();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input) => announceNotification(input, fetchImpl),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: AUDIT_ROOT_KEY });
    },
  });
}
